import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { FindCellTemplatePipe, HeaderCellCaptionPipe } from './pipes';
import { CellTemplateDirective, RowDetailTemplateDirective } from './directives';
import { DataTableComponent } from './components';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';
import { SelectAllCheckboxStatePipe } from '../../../pipes';
import { MatPseudoCheckboxModule } from '@angular/material/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    declarations: [
        DataTableComponent,
        CellTemplateDirective,
        FindCellTemplatePipe,
        HeaderCellCaptionPipe,
        RowDetailTemplateDirective,
    ],
    exports: [
        DataTableComponent,
        CellTemplateDirective,
        RowDetailTemplateDirective,
    ],
	imports: [
		DisableAutocompleteDirectiveModule,
		MatTableModule,
		CommonModule,
		MatSortModule,
		MatProgressBarModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatTooltipModule,
		MatMenuModule,
		SelectAllCheckboxStatePipe,
		MatPseudoCheckboxModule,
		FontAwesomeModule,
	],
})
export class DataTableModule {}
